import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const StoreSummary = ({ name , streetName , streetNumber , actions  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Card, {
        "data-t": "service-store-summary"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, (actions === null || actions === void 0 ? void 0 : actions.onEdit) && /*#__PURE__*/ React.createElement(Card.Actions, null, /*#__PURE__*/ React.createElement(Card.Button, {
        onClick: actions.onEdit,
        children: getLabel('common.actions.edit')
    })), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, getLabel('checkout.serviceStore.title')), /*#__PURE__*/ React.createElement(Card.Text, null, name), /*#__PURE__*/ React.createElement(Card.Text, null, streetName, " ", streetNumber)));
};

export { StoreSummary };
//# sourceMappingURL=StoreSummary.js.map
